import { YalwaButton } from './button.js';

export class YalwaChip extends YalwaButton {
 
	static get observedAttributes() {
		return [...super.observedAttributes, 'closable'];
	}
	
	get closable() {
		return this.hasAttribute('closable');
	}
	
	set closable(value) {
		if (value) {
			this.setAttribute('closable', '');
		} else {
			this.removeAttribute('closable');
		}
	}
	
	render() {
		super.render();
		const $button = jQuery(this.core_element);
		if (this.closable) {
			$button.attr('closable', '');
		} else {
			$button.attr('closable', null);
		}
	}
}

customElements.define('yalwa-chip', YalwaChip);